import React, {useState, useEffect} from 'react';
import {LinearGradient} from 'expo-linear-gradient';
import { fontFamily } from '../../helpers/fontFamily';
import { Image, Text, View,StyleSheet, TouchableOpacity } from 'react-native';
import i18n from 'i18n-js';
const DisplayImage = (props) => {
  const [showDefault, setShowDefault] = useState(false)
  let slider_image = [];
  const hideMenu = props.hideMenu ?? false;
  useEffect(()=>{
  if(props.images.length < 1){
      setShowDefault(true)
      return;
  }
  setShowDefault(false)
  },[props.images[0]?.image])
  return (
    <View style={style.container}>
      <View style={style.mainContainer}>
        {props.images.map(
          (image, index) => {
            slider_image.push(image.image);
          }
        )}
        {showDefault ?(
          <Image
            onError={props.onError}
            source={props.source}
            style={style.image}
          />
        ) : (
          <Image
            source={{uri:slider_image[0]}}
            onError={() => {
              setShowDefault(true)
            }}
            style={style.image}
          />
        )}
        <LinearGradient
          colors={['rgba(0, 0, 0, 0)', 'rgba(20, 20, 20, 0.9)']}
          locations={[0, 1]}
          start={{ x: 0, y: 0.5 }}
          end={{ x: 1, y: 0.5 }}
          style={style.gradient}
        />

        {!hideMenu && (
          <TouchableOpacity
            testID='menuIcon'
            onPress={props.updateShowMenu}
            style={style.iconContainer}
          >
            <i
              className="icon-menu"
              style={{color: 'gray', fontSize: 24, marginLeft: -10}}>
            </i>
          </TouchableOpacity>
        )}
        
        <View style={style.gradient1}>
          <Text
            style={[
              {
                fontWeight: 'bold',
                fontFamily: fontFamily.font700,
                fontSize: 22,
                marginTop: 1,
                background:
                  '-webkit-linear-gradient( #5a758d, #324a64)',
                webkitBackgroundClip: 'text',
                webkitTextFillColor: 'transparent',
                lineHeight: 22,
              }]
            }
          >
            {props.scanned_qty} /{' '}
            {props.total_qty}
          </Text>
          <Text
            style={style.text}
          >
            {i18n.t("scanpackItem.scannedLabel")}
          </Text>
        </View>
      </View>
    </View>
  )
}
export default DisplayImage;

const style = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    height: 166
  },
  mainContainer: {
    height: 165,
    width: 175,
    position: 'relative',
    marginTop: 10,
    zIndex: 9,
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: 18,
    borderBottomLeftRadius: 18,
    shadowColor: '#000000',
    shadowOpacity: 0.3,
    shadowRadius: 10,
    shadowOffset: {
      width: 3,
      height: 5
    },
    overflow: 'hidden',
  },
  gradient: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '15%',
    height: '100%',
    zIndex: 16
  },
  iconContainer: {
    padding: 10,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    top: '10%',
    zIndex: 20,
    width: '100%',
    position: 'absolute'
  },
  image: {
    height: '100%',
    width: '100%',
    resizeMode: 'cover',
    borderTopLeftRadius: 18,
    borderBottomLeftRadius: 18,
  },
  text: {
    textAlign: 'center',
    fontSize: 12,
    color: '#000',
    fontFamily: fontFamily.font600,
    textTransform: 'uppercase',
    lineHeight: 13
  },
  gradient1: {
    width: '100%',
    position: 'absolute',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: fontFamily.font600,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderBottomLeftRadius: 18,
    bottom: 0,
    right: 0,
    left: 0,
    zIndex: 10,
    paddingVertical: 5,
  }
});
